import React from 'react';
import './styles/PieChart.css';

const PieChart = ({ data }) => {
  // Ensure data is an array before reducing
  const safeData = Array.isArray(data) ? data : [];
  const total = safeData.reduce((sum, item) => sum + (item.value || 0), 0);
  let cumulativePercent = 0;

  // Check if total is zero to avoid division by zero
  if (total === 0) {
    return (
      <div className="pie-chart-container">
        <h2>Review Distribution</h2>
        <div className="no-data-message">No review data available to display distribution.</div>
      </div>
    );
  }

  // Generate the conic-gradient string
  const gradientSegments = safeData.map(item => {
    const value = Number(item.value) || 0;
    const percent = (value / total) * 100;
    const startAngle = cumulativePercent * 3.6;
    cumulativePercent += percent;
    const endAngle = cumulativePercent * 3.6;
    // Ensure angles don't exceed 360 slightly due to floating point issues
    const clampedEndAngle = Math.min(endAngle, 360);
    // Format: color from start_angle to end_angle
    return `${item.color} ${startAngle}deg ${clampedEndAngle}deg`;
  }).join(', '); // Join segments with commas

  const conicGradientStyle = {
    background: `conic-gradient(${gradientSegments})`
  };

  // Reset cumulativePercent for mapping slices for tooltips
  cumulativePercent = 0;

  return (
    <div className="pie-chart-container">
      <h2>Review Distribution</h2>
      <div className="pie-chart-wrapper">
        {/* Apply the generated conic-gradient style to the main pie element */}
        <div className="pie-chart" style={conicGradientStyle}>
          {/* Keep slices for tooltips, but they won't draw colors */}
          {safeData.map((item, index) => {
            const value = Number(item.value) || 0;
            const percent = (value / total) * 100;

            return (
              <div
                key={index}
                className="pie-slice" // CSS will make this transparent
                // No inline style needed for drawing slices
                title={`${item.label}: ${Math.round(percent)}% (${value} reviews)`}
              />
            );
          })}
          <div className="pie-center"></div> {/* Optional center element */}
        </div>
      </div>
      {/* Legend remains the same */}
      <div className="pie-legend">
        {safeData.map((item, index) => {
           // Ensure item.value is a number for display
           const value = Number(item.value) || 0;
           const percent = total > 0 ? Math.round((value / total) * 100) : 0;
           return (
             <div key={index} className="legend-item">
               <div
                 className="legend-color"
                 style={{ backgroundColor: item.color }}
               ></div>
               <div className="legend-label">{item.label}</div>
               <div className="legend-value">
                 {value} ({percent}%)
               </div>
             </div>
           );
        })}
      </div>
    </div>
  );
};

export default PieChart;